import React from 'react';

const Clients = () => {
  const clients = Array.from({ length: 18 }, (_, i) => ({
    id: i + 1,
    image: `${process.env.PUBLIC_URL}/clients/client-${i + 1}.png`
  }));

  return (
    <section className="py-28 bg-gradient-to-b from-navy-800 to-navy-900">
      <div className="text-center mb-16 px-4">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Trusted by the most <span className="text-silver-300">innovative companies</span> in the world
        </h2>
      </div>

      <div className="relative overflow-hidden py-4">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-navy-900 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-navy-900 to-transparent z-10 pointer-events-none"></div>

        <div className="marquee-track">
          <div className="marquee-content">
            {clients.map((client) => (
              <img
                key={client.id}
                src={client.image}
                alt={`Client ${client.id}`}
                className="h-28 w-auto object-contain"
                style={{ minWidth: '120px', margin: '0 32px' }}
              />
            ))}
          </div>
          <div className="marquee-content" aria-hidden="true">
            {clients.map((client) => (
              <img
                key={`dup-${client.id}`}
                src={client.image}
                alt=""
                className="h-28 w-auto object-contain"
                style={{ minWidth: '120px', margin: '0 32px' }}
              />
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .marquee-track {
          display: flex;
          width: max-content;
          animation: marquee 18s linear infinite;
        }
        .marquee-content {
          display: flex;
          align-items: center;
          flex-shrink: 0;
        }
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Clients;
